import React from "react";
import moment from "moment";
import Currency from "react-currency-formatter";
import information from '~/assets/images/information.svg';

import {
  Container,
  Title,
  ItemDetails,
  Details,
  IconInformation,
  Left,
  Right
} from "./styles";

export default function Item({ data, openModal }) {
  let invoice = data;
  return (
    <Container className="mb-3">

      <Left>
        <Title>
          {moment(invoice.emissionDate).add(1, "d").format("MMMM/YYYY")}
        </Title>
        <ItemDetails>
          <Title style={{ marginRight: 8 }}>Emissão: </Title>
          {moment(invoice.emissionDate).add(1, "d").format("DD/MM/YYYY")}
        </ItemDetails>
      </Left>

      <Right>
        <Title>
          <Currency quantity={invoice.totalAmount} currency="BRL" locale="pt" />
        </Title>
        <Details onClick={() => openModal()}>
          Detalhes
          <img src={information} style={IconInformation} />
        </Details>

      </Right>

    </Container>
  );
}